/**
 * @author       jose.lucena@zumper.com (José Lucena)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { RentalDataLocation } from '@zcode/bizos'
import { falseReducer, trueReducer } from '@zcode/reducers'
import type { CurrentSearch } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleActions } from 'redux-actions'
import type * as actions from '../actions/rentResearch'
import {
  DONE_FETCHING_RENT_RESEARCH,
  ERROR_FETCHING_RENT_RESEARCH,
  RECEIVE_RENT_RESEARCH,
  START_FETCHING_RENT_RESEARCH,
} from '../constants/rentResearch'

type Actions = ExtractActions<Values<typeof actions>>
export const allowedList = [
  RECEIVE_RENT_RESEARCH,
  DONE_FETCHING_RENT_RESEARCH,
  START_FETCHING_RENT_RESEARCH,
  ERROR_FETCHING_RENT_RESEARCH,
] as const satisfies ReadonlyArray<Actions['type']>

declare const shouldBeEmpty: Exclude<Actions['type'], (typeof allowedList)[number]>
false && (shouldBeEmpty satisfies never)

export const rentResearchReducer = combineReducers<CurrentSearch['rentalData'], Actions>({
  fetching: handleActions(
    {
      [START_FETCHING_RENT_RESEARCH]: trueReducer,
      [DONE_FETCHING_RENT_RESEARCH]: falseReducer,
      [ERROR_FETCHING_RENT_RESEARCH]: falseReducer,
    },
    false
  ),
  data: handleActions<CurrentSearch['rentalData']['data'], Actions>(
    {
      [RECEIVE_RENT_RESEARCH]: (
        state: CurrentSearch['rentalData']['data'],
        { payload }: { payload: RentalDataLocation }
      ) => payload,
    },
    null
  ),
})
